module.exports = __webpack_public_path__ + "img/icons8-chevrolet.89c20352.svg";